import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee9b33c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section userData" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title sub-title" }, "申出者に関する項目", -1))
const _hoisted_3 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmInput = _resolveComponent("ConfirmInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", null, [
        _createVNode(_component_ConfirmInput, {
          name: '氏名',
          value: _ctx.state.name,
          class: _normalizeClass('name')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '所属機関・企業・団体',
          value: _ctx.state.institution,
          class: _normalizeClass('institution')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: 'メールアドレス',
          value: _ctx.state.mailAddress,
          class: _normalizeClass('mailAddress')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '申出のオンライン資料と申出者の関係',
          value: _ctx.state.relation,
          class: _normalizeClass('relation')
        }, null, 8, ["value"])
      ])
    ])
  ]))
}